import React, { useRef, useState } from 'react';
import Icon from '../../../components/AppIcon';

const DropZone = ({ onFileSelected, isProcessing, fileName }) => {
  const [isDragging, setIsDragging] = useState(false);
  const inputRef = useRef(null);

  const handleDragOver = (e) => {
    e?.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => setIsDragging(false);

  const handleDrop = (e) => {
    e?.preventDefault();
    setIsDragging(false);
    const file = e?.dataTransfer?.files?.[0];
    if (file) onFileSelected?.(file);
  };

  const handleChange = (e) => {
    const file = e?.target?.files?.[0];
    if (file) onFileSelected?.(file);
    e.target.value = '';
  };

  return (
    <div
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onClick={() => inputRef?.current?.click()}
      className={`relative flex flex-col items-center justify-center border-2 border-dashed rounded-xl p-10 cursor-pointer transition-all ${
        isDragging ? 'border-accent bg-accent/5' : 'border-border hover:border-accent/50 hover:bg-surface'
      }`}
    >
      <input
        ref={inputRef}
        type="file"
        accept=".csv"
        className="hidden"
        onChange={handleChange}
      />
      {isProcessing ? (
        <>
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-accent mb-3" />
          <p className="text-sm text-text-secondary">Parsing CSV…</p>
        </>
      ) : fileName ? (
        <>
          <Icon name="FileCheck" size={36} className="text-success mb-3" />
          <p className="text-sm font-medium text-text-primary">{fileName}</p>
          <p className="text-xs text-text-secondary mt-1">Click to replace</p>
        </>
      ) : (
        <>
          <Icon name="UploadCloud" size={36} className="text-text-secondary mb-3" />
          <p className="text-sm font-medium text-text-primary">Drag & drop a CSV file here</p>
          <p className="text-xs text-text-secondary mt-1">or click to browse</p>
        </>
      )}
    </div>
  );
};

export default DropZone;
